import { defaultMenuItemImage } from '../paths/defaultImage';

export const menuImageErrorHander = (elem) => (elem.target.src = defaultMenuItemImage);
